"use strict";

import "./select-companies-import-type-dialog.scss";
import angular from "angular";

class SelectCompaniesImportTypeDialogCtrl {
    constructor(
        $mdDialog,
        DSNDialogService,
        locals,
        $state,
        ChatAtendimentoService
    ) {
        this.locals = locals;
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
        this.$state = $state;
        this.ChatAtendimentoService = ChatAtendimentoService;
    }
    $onInit() {}
    onRedirectToCadsim() {
        this.$mdDialog.cancel();
        this.$state.go("nucont.accounting.journey.import.cadsim", {
            from: this.locals.from
        });
    }
    onRedirectToExcel() {
        this.$mdDialog.cancel();
        this.$state.go("nucont.accounting.journey.import.spreadsheet", {
            from: this.locals.from
        });
    }
    onRedirectToTableNu() {
        this.$mdDialog.cancel();
        this.$state.go("nucont.accounting.journey.import.manualTable", {
            from: this.locals.from
        });
    }
    onRedirectToDocument() {
        this.$mdDialog.cancel();
        this.$state.go("nucont.accounting.journey.import.document", {
            from: this.locals.from
        });
    }
    onOpenChat() {
        this.$mdDialog.cancel();
        this.ChatAtendimentoService.open();
    }
    onRedirectToCertificate() {
        this.$mdDialog.hide();
        this.$state.go("nucont.accounting.integration.certificate", {
            source: "certificado"
        });
    }
}

angular.module("nucont.shared").controller("SelectCompaniesImportTypeDialogCtrl", [
    "$mdDialog",
    "DSNDialogService",
    "locals",
    "$state",
    "ChatAtendimentoService",
    SelectCompaniesImportTypeDialogCtrl
]);
